import React from 'react';
import { Grid } from '@mui/material';
import { useTheme } from '@mui/system';

export const FireblocksImage = () => {
  const theme = useTheme();
  return (
    <Grid item>
      <img
        src={`/images/signup/fireblocks-seal-${theme.palette.mode}.svg`}
        alt='fireblocks'
        id={'fireblocks_icon'}
      />
    </Grid>
  );
};

export default FireblocksImage;
